import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { CreateModelDialog } from '@/components/workspace/CreateModelDialog'

export const Route = createFileRoute('/test-create-model')({
  component: TestCreateModelPage,
})

function TestCreateModelPage() {
  const [open, setOpen] = useState(false)

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-8">
      <div className="flex flex-col items-center gap-2">
        <h1 className="text-2xl font-bold">Create Model Dialog — Demo</h1>
        <p className="text-muted-foreground">
          Click the button below to open the training dialog
        </p>
      </div>

      <Button size="lg" onClick={() => setOpen(true)}>
        Open Create Model Dialog
      </Button>

      <CreateModelDialog open={open} onOpenChange={setOpen} />
    </div>
  )
}
